import { render, staticRenderFns } from "./V2RetailerDashboard.vue?vue&type=template&id=422c9aab&scoped=true&"
import script from "./V2RetailerDashboard.vue?vue&type=script&lang=js&"
export * from "./V2RetailerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./V2RetailerDashboard.vue?vue&type=style&index=0&id=422c9aab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c9aab",
  null
  
)

export default component.exports